/**
 * Team tab (plan section 13 tab 6; admin only): a SegmentedTabs shell over
 * the sub-views in tabs/team/subviews.ts (Matrix, People, Sign-offs, External
 * certificates, Onboarding, Reports, Verify a certificate).
 *
 * Hot file (plan 15.12): WP-03 only. The sub-view WPs (WP-45, WP-47) replace
 * the placeholder file their registry entry imports and never edit this one.
 * LmsApp mounts it at /lms/team/* behind the admin check.
 */
import { SubviewHost } from '../../components/SubviewHost';
import { lmsTab } from '../config';
import { TEAM_SUBVIEWS } from './subviews';

const TAB = lmsTab('team');

export function TeamTab() {
  return <SubviewHost tab={TAB} subviews={TEAM_SUBVIEWS} />;
}

export default TeamTab;
